var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { config } from './config';
var _env = {
    production: false,
    envName: 'qa',
    baseUrl: 'https://api-v2-staging.eyrus.com',
    apexUrl: 'https://app-staging.eyrus.com/project/{projectId}/home',
    sentryDsn: 'https://0367d34d510044eb9292fdf0a137e120@sentry.io/1798683',
    firebase: {},
    // Google Analytics
    ga: {
        url: 'https://www.googletagmanager.com/gtag/js?id=UA-71851211-5',
        ua: 'UA-71851211-5'
    },
    stripe: {
        key: 'pk_test_Zrvkt1LgTmJnJIXO41DniARS'
    }
};
export var environment = __assign({}, _env, config());
